<template>
  <div>
     <v-btn @click="showDialog = true">Add Ride type to Region</v-btn>
    <v-flex pt-4>
     <v-expansion-panels>
     <v-expansion-panel
        v-for="arttt in rideTypesStore"
        :key="arttt.id"
        :color="arttt.ride_type.enabled ? 'white' : 'grey lighten-2'"
      >
        <v-expansion-panel-header>
        <v-layout align-center row>
          <v-flex xs1 md1 pl-2 pt-1 pb-1>
            <v-avatar color="grey lighten-4" :size="64">
              <img :src="arttt.ride_type.image" />
            </v-avatar>
          </v-flex>
          <v-flex xs1 md1 pl-2 pt-1 pb-1>
            <v-avatar color="grey lighten-4" :size="16">
              <img :src="arttt.ride_type.alternative_image" />
            </v-avatar>
          </v-flex>
          <v-flex xs2 md2>
            <v-card-title
              ><h3>{{ arttt.ride_type.name }}</h3></v-card-title
            >
          </v-flex>
          <v-flex xs2 md2>
            {{ arttt.ride_type.description }}
          </v-flex>
          <v-flex xs1 md1 pr-2>
            <v-layout justify-end>
              <v-card-actions>
                <v-btn icon ripple @click="edit(arttt.ride_type.id)">
                  <v-icon color="grey lighten-1">edit</v-icon>
                </v-btn>
                  <v-flex pl-3 pt-4><v-switch v-model="arttt.enabled" @change="toggleTariff(arttt)" label="Enabled">
                  </v-switch>
                  </v-flex>
              </v-card-actions>
            </v-layout>
          </v-flex>
        </v-layout>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <AvailabilityRegionRideTypeForm :arttt="arttt" />
        </v-expansion-panel-content>
     </v-expansion-panel>
     </v-expansion-panels>
    </v-flex>
      <v-dialog
        v-model="showDialog"
        width="600px"
      >
      <v-card>
        <v-card-title>
          <span class="headline">Select Ride Type</span>
        </v-card-title>
        <v-layout
          column
          px-4
        >
          <SelectableRideTypeForAvailabilityRegion @input="rideTypeSelected" :rideTypes="rideTypesAvailableForAvailabilityRegion"/>
        </v-layout>
        <v-card-actions >
          <v-spacer />
          <v-btn
            class="text-none"
            text
            @click="showDialog = false"
          >
            Cancel
          </v-btn>
          <v-btn
            class="text-none"
            text
            @click="add()"
            v-if="selectedRideType != null"
          >
            Add
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import draggable from "vuedraggable";

import AvailabilityRegionRideTypeForm from "@/components/settings/pricing/AvailabilityRegionRideTypeForm.vue";
import SelectableRideTypeForAvailabilityRegion from "@/components/settings/pricing/SelectableRideTypeForAvailabilityRegion.vue";

import axios from "axios";

axios.defaults.withCredentials = true;

export default {
  name: "ride_type_list",
  components: {
    draggable,
    AvailabilityRegionRideTypeForm,
    SelectableRideTypeForAvailabilityRegion
  },
  props: {
    ride_types: Array,
    loading: Boolean,
    loadingCostEstimates: Boolean,
    availabilityRegion: Object
  },
  data: function () {
    return {
      rideTypesStore: [],
      showDialog: false,
      rideTypes: [],
      selectedRideType: null,
    };
  },
  beforeMount: async function () {
    this.rideTypesStore = this.ride_types;
  },
  mounted: function() {
    this.getRideTypes();
  },
  computed: {
    rideTypesAvailableForAvailabilityRegion: function() {

      var self = this;
      return this.rideTypes.filter(function(r) {
        
        for (var i = 0; i < self.rideTypesStore.length; i++) {
          if (self.rideTypesStore[i].ride_type.id == r.id) {
            return false;
          }
        }

        return true;

      }); 
    }
  },
  methods: {
    toggleTariff(t) {
      console.log("toggle " + t.enabled )


      let self = this;
      let url = `${this.$store.state.apiUrl}/availability_region/tariffs/${t.id}/toggleEnabled?enabled=${t.enabled}`;


      axios({
        url: url,
        method: "post",
        headers: {
          "Content-Type": "text/plain",
        },
      })
        .then(function (response) {
          console.log(response.data.errors);
          
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    rideTypeForId(id) {
      for (var i = 0; i < this.rideTypes.length; i++) {
        if (id == this.rideTypes[i].id) {
          return this.rideTypes[i];
        }
      }
    },
    add() {
      var arrtt = {
        availability_region_id: this.availabilityRegion.id,
        ride_type_id: this.selectedRideType,
        ride_type: this.rideTypeForId(this.selectedRideType),
        tariff: {
          base_fare: "",
          per_mile_fare: "",
          per_minute_fare: "",
          additional_charge: "",
          minimum_fare: "",
          modifiers: [],
        },
        enabled: true,
      }

      console.log(arrtt);

      this.rideTypesStore.push(arrtt);
      this.showDialog = false;
    },
    rideTypeSelected: function(rtt) {
      console.log("RTT")
      console.log(rtt);

      this.selectedRideType = rtt;
    },
    getRideTypes: async function () {

      console.log("getting ride types");

      try {
        var url = `${this.$store.state.apiUrl}/ride_types/all`;

        let response = await axios.get(url, {
          params: {},
        });

        this.rideTypes = response.data;

        console.log("got ride types");
      } catch (error) {
        this.loading = false;
        console.log("Failed to get ride types " + error);
      }
    },
    edit: function (id) {
      this.$emit("edit", id);
    },
    orderChanged: function () {
      this.$emit("orderChange", this.rideTypesStore);
    },
   
  },
  watch: {
    ride_types: function () {
      this.rideTypesStore = this.ride_types;
    },
    rideTypesStore: function () {},
  },
};
</script>
